<template>
  <app-layout title="Firebase">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Firebase連携
      </h2>
    </template>
    <div class="mx-auto px-4 py-4 flex flex-col items-center">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="flex flex-row-reverse">
          <button
            class="m-5 px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
            @click.prevent="onSyncClicked">
            問題を同期する(→Firestore)
          </button>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import AppLayout from '@/Layouts/AppLayout'

const onSyncClicked = () => {
  Inertia.get('firebase/sync-firestore')
}
</script>
